import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

export default () => {

    const auth = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        console.log("auth: ", auth)
        if(auth.isAuthenticated){
            navigate("/app")
        }
    }, [auth]) 

    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>Signing you in...</div>;
        case "signoutRedirect":
            return <div>Signing you out...</div>;
    }

    return (
        <div style={{display: "flex", flexDirection: "column", gap: "12px"}}>
            In process
        </div>
    )
}